export const customers = [
  {
    id: 1,
    name: "Luke",
    lastname: "Skywalker",
    note: "Jedi Master",
    blacklist: false,
    marketingAgreement: false,
    tel: "+123456001",
    email: "luke@tatoine.com",
  },
  {
    id: 2,
    name: "Darth",
    lastname: "Vader",
    note: "Sith Lord",
    blacklist: true,
    marketingAgreement: false,
    tel: "+999456002",
    email: "father@vader.com",

  },
  {
    id: 3,
    name: "Princess",
    lastname: "Leia",
    note: "General of the Resistance",
    blacklist: false,
    marketingAgreement: false,
    tel: "+000456003",
    email: "princess@princess.com",
  },
  {
    id: 4,
    name: "Han",
    lastname: "Solo",
    note: "Smuggler and Captain of the Millennium Falcon",
    blacklist: false,
    marketingAgreement: false,
    tel: "+123456004",
    email: "han@han.com",
  },
  {
    id: 5,
    name: "Chewbacca",
    lastname: "",
    note: "Wookiee and Co-Pilot of the Millennium Falcon",
    blacklist: false,
    marketingAgreement: false,
    tel: "+555456005",
    email: "chewbacca@chewbac.com",
  },
  {
    id: 6,
    name: "Yoda",
    lastname: "",
    note: "Jedi Master",
    blacklist: false,
    marketingAgreement: false,
    tel: "+777456006",
    email: "yoda@yoda.com",
  },
  {
    id: 7,
    name: "Obi-Wan",
    lastname: "Kenobi",
    note: "Jedi Master",
    blacklist: false,
    marketingAgreement: false,
    tel: "+123456001",
    email: "kenobi@kenobi.com",
  },
  {
    id: 8,
    name: "R2-D2",
    lastname: "",
    note: "Droid",
    blacklist: false,
    marketingAgreement: false,
    tel: "+123456002",
    email: "r2-D2@kenobi.com",
  },
  {
    id: 9,
    name: "C-3PO",
    lastname: "",
    note: "Protocol Droid",
    blacklist: true,
    marketingAgreement: false,
    tel: "+123456003",
    email: "protocol@proto.com",
  },
  {
    id: 10,
    name: "Padmé",
    lastname: "Amidala",
    note: "Queen of Naboo",
    blacklist: false,
    marketingAgreement: false,
    tel: "+123456014",
    email: "padm@padm.com",
  },
  {
    id: 11,
    name: "Qui-Gon",
    lastname: "Jinn",
    note: "Jedi Master",
    blacklist: false,
    marketingAgreement: false,
    tel: "+123456011",
    email: "qui@qui.com",
  },
  {
    id: 12,
    name: "Mace",
    lastname: "Windu",
    note: "Jedi Master",
    blacklist: false,
    marketingAgreement: false,
    tel: "+111456012",
    email: "windu@windcom.com",
  },
  {
    id: 13,
    name: "Darth",
    lastname: "Maul",
    note: "Sith Lord",
    blacklist: true,
    marketingAgreement: false,
    tel: "+222456013",
    email: "maulie@maul.com",
  },
  {
    id: 14,
    name: "Boba",
    lastname: "Fett",
    note: "Bounty Hunter",
    blacklist: true,
    marketingAgreement: false,
    tel: "+333456014",
    email: "bob@bob.com",
  },
  {
    id: 15,
    name: "Jango",
    lastname: "Fett",
    note: "Bounty Hunter",
    blacklist: true,
    marketingAgreement: false,
    tel: "+444456015",
    email: "jango@fett.com",
  },
  {
    id: 16,
    name: "General",
    lastname: "Grievous",
    note: "Cyborg and Separatist General",
    blacklist: true,
    marketingAgreement: false,
    tel: "+555456016",
    email: "",
  },
  {
    id: 17,
    name: "Ahsoka",
    lastname: "Tano",
    note: "Former Padawan",
    blacklist: false,
    marketingAgreement: false,
    tel: "+666456017",
    email: "",
  },
  {
    id: 18,
    name: "Sheev",
    lastname: "Palpatine",
    note: "Sith Lord and Emperor",
    blacklist: true,
    marketingAgreement: false,
    tel: "+777456018",
    email: ""
  },
  {
    id: 19,
    name: "Count",
    lastname: "Dooku",
    note: "Sith Lord",
    blacklist: true,
    marketingAgreement: false,
    tel: "+888456019",
    email: "",
  },
  {
    id: 20,
    name: "Finn",
    lastname: "",
    note: "Former Stormtrooper",
    blacklist: false,
    marketingAgreement: false,
    tel: "+999456020",
    email: "",
  },
  {
    id: 21,
    name: "Rey",
    lastname: "",
    note: "Jedi",
    blacklist: false,
    marketingAgreement: false,
    tel: "+123456021",
    email: ""
  },
  {
    id: 22,
    name: "Poe",
    lastname: "Dameron",
    note: "Resistance Pilot",
    blacklist: false,
    marketingAgreement: true,
    tel: "+123456022",
    email: "",
  },
  {
    id: 23,
    name: "Kylo",
    lastname: "Ren",
    note: "Supreme Leader of the First Order",
    blacklist: true,
    marketingAgreement: false,
    tel: "+123456023",
    email: "",
  },
  {
    id: 24,
    name: "Lando",
    lastname: "Calrissian",
    note: "Former Baron Administrator of Cloud City",
    blacklist: false,
    marketingAgreement: true,
    tel: "+123456024",
    email: "",
  },
  {
    id: 25,
    name: "Jabba",
    lastname: "the Hutt",
    note: "Crime Lord",
    blacklist: true,
    marketingAgreement: false,
    tel: "+123456025",
    email: "",
  },
  {
    id: 26,
    name: "Wedge",
    lastname: "Antilles",
    note: "Starfighter Pilot",
    blacklist: false,
    marketingAgreement: true,
    tel: "+123456026",
    email: "",
  },
  {
    id: 27,
    name: "Maz",
    lastname: "Kanata",
    note: "Pirate and Tavern Owner",
    blacklist: false,
    marketingAgreement: false,
    tel: "+123456027",
    email: "",
  },
  {
    id: 28,
    name: "Admiral",
    lastname: "Ackbar",
    note: "Mon Calamari Commander",
    blacklist: false,
    marketingAgreement: true,
    tel: "+123456028",
    email: "",
  },
  {
    id: 29,
    name: "Rose",
    lastname: "Tico",
    note: "Resistance Mechanic",
    blacklist: false,
    marketingAgreement: true,
    tel: "+123456029",
    email: "",
  },
  {
    id: 30,
    name: "Captain",
    lastname: "Phasma",
    note: "First Order Officer",
    blacklist: true,
    marketingAgreement: false,
    tel: "+123456030",
    email: "",
  },
  {
    id: 31,
    name: "Greedo",
    lastname: "",
    note: "Bounty Hunter",
    blacklist: true,
    marketingAgreement: false,
    tel: "+123456031",
    email: "",
  },
]
